import styled from 'styled-components';
import { space, layout, flexbox } from 'styled-system';
import { StyledProps } from 'types/styles';

interface Props extends StyledProps {}

export const Wrapper = styled.form<Props>`
  position: relative;
  
  ${layout}
  ${flexbox}
  ${space}
`;
